enum FormType {
    PERSONAL_INFO,
    GENERAL_MEDICAL_INFO,
    SYMPTOMS,
    READY
  }
  
  export default FormType;
  